<template>
  <div class="form-control disabled">
    <Component
      :is="getComponent"
      v-bind="$attrs"
      v-on="$listeners"
    />
  </div>
</template>
<script>
import Index from './Status/Index';
import IndexOnSale from './Status/IndexOnSale';
import IndexOutOfStock from './Status/IndexOutOfStock';
import IndexRejected from './Status/IndexRejected';
import IndexActionNeeded from './Status/IndexActionNeeded';
import IndexNotOnSale from './Status/IndexNotOnSale';

export default {
  name: 'Status',
  computed: {
    getComponent () {
      const { route } = this.$route.query;
      return {
        ListingAll: Index,
        ListingOnSale: IndexOnSale,
        ListingOutOfStock: IndexOutOfStock,
        ListingRejected: IndexRejected,
        ListingNotOnSale: IndexNotOnSale,
        ListingActionNeeded: IndexActionNeeded,
      }[route] || Index;
    },
  },
};
</script>
